export const removePreventInitAttr = (els: HTMLElement[]) => {
    els.forEach((el) => el.removeAttribute('preventInit'));
};
